import { render, staticRenderFns } from "./NewMaintTaskInfo.vue?vue&type=template&id=19a77989&scoped=true&"
import script from "./NewMaintTaskInfo.vue?vue&type=script&lang=js&"
export * from "./NewMaintTaskInfo.vue?vue&type=script&lang=js&"
import style0 from "./NewMaintTaskInfo.vue?vue&type=style&index=0&id=19a77989&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a77989",
  null
  
)

export default component.exports